import script from "./MoreInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./MoreInfo.vue?vue&type=script&setup=true&lang=ts"

import "./MoreInfo.vue?vue&type=style&index=0&id=dadcaf7a&scoped=true&lang=css"

import exportComponent from "/ws/483d663ba9f2473cb9ed84f25e5f2ea6/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dadcaf7a"]])

export default __exports__